// extracted by mini-css-extract-plugin
export default {"pageWrap":"Yb-z","fullWidth":"Zb-z","heading":"_b-z","fullBleed":"ac-z","hidden":"bc-z"};